import React from "react";
// import Layout from 'layout/index.js'

// import { Link } from 'react-router-dom';


// import withRouter  from 'adds/router/withRouter.js';
import { withRouter } from 'react-router-dom'
// import SearchIcon from '@mui/icons-material/Search';

import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import DeleteIcon from '@mui/icons-material/Delete';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import IconButton from '@mui/material/IconButton';
import Permiso from "./Permiso";

import { authenticationService } from 'auth/authenticationService'
import {
          Paper,
          Box,
          Button,
          Typography,
          Alert,
          // TextField,
          TableSortLabel,TablePagination,TableContainer,Table,TableRow,TableHead,TableBody,TableCell,
          // FormControl, InputLabel, Select, MenuItem, 
          // CircularProgress,
          Grid,
          Collapse, 
          Dialog, DialogContent, DialogActions, DialogTitle,
        } from '@mui/material';

const headCells = [
  { id: "collapse_col", numeric: false, disablePadding: false, label: "", sorting: false},
  { id: "Fechas relevantes", numeric: false, disablePadding: false, label: "Fechas relevantes", sorting: false},
  { id: "informacion", numeric: false,disablePadding: false,label: "Información vehículo", sorting: false},
  { id: "estado", numeric: false,disablePadding: false,label: "Estado del permiso", sorting: false},
  { id: "estadisticas", numeric: false,disablePadding: false,label: "Estadísticas", sorting: false},
  { id: "username", numeric: false,disablePadding: false,label: "Agente", sorting: false},
  { id: "detalles", numeric: false, disablePadding: false, label: "Ver", sorting: false},
];

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map(headCell => (
          !headCell.sorting ? <TableCell key={headCell.id}>{headCell.label}</TableCell> : (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className='hideSort'>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
          )
        ))}
      </TableRow>
    </TableHead>
  );
}
function encodeQueryData(data) {
   const ret = [];
   for (let d in data)
     ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
   return ret.join('&');
}



class PermisosHistoricos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

      objects: [],

      html: {
        list: true,
        dialog: false,
        delete_dialog: false,
        selected_permiso: null,
        selected_permiso_for_delete: null,
        rows:[],
      },
      filters: {
      },
      pagination:{
        page: 0,
        pages_num: 1,
        rows_num: -1,
        rows_per_page: 10,
      },
      sorting: {
        order_by:'created_at',
        order:'desc',
      },
    };

    this.handleLoad = this.handleLoad.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleRow = this.handleRow.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.openDeleteDialog = this.openDeleteDialog.bind(this);
    this.closeDeleteDialog = this.closeDeleteDialog.bind(this);
    this.deletePermiso = this.deletePermiso.bind(this);

  }



  handleChangePage(event, page){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          page: page,
      }}), ()=> this.handleLoad());

  }
  handleChangeRowsPerPage(event){
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
          rows_per_page: event.target.value,
      }}), ()=> this.handleLoad());
  }

  handleSort(event, property){
    const isAsc = this.state.sorting.order_by === property && this.state.sorting.order === "asc";
    this.setState(prevState => ({
      sorting: {
          ...prevState.sorting,
          order: isAsc ? "desc" : "asc",
          order_by: property,
    }}),()=>this.handleLoad()
    );

  }


  handleLoad(){

    var params = {
        page: this.state.pagination.page+1,
        order_by: this.state.sorting.order_by,
        order: this.state.sorting.order,
        rows_per_page: this.state.pagination.rows_per_page,
    };


    params['vehiculo_uuid'] = this.props.vehiculo_uuid;

    var query = encodeQueryData(params)

    authenticationService.fetchApi({
      url:'/permisos/permiso/?'+query,
      method: 'GET',
    })
    .then(result=>{
      let list = false;
      if(result.data.length > 0){
        list=true;
      }
      this.setState(prevState => ({
        pagination: {
            ...prevState.pagination,
            rows_num: result.pagination.rows_num
        },
        html: {
          ...prevState.html,
          list: list,
        },
        objects: result.data
      }));
    })
    .catch(err=>{

    });

  }
  deletePermiso(){

    var params = {
      permiso_uuid: this.state.objects[this.state.html.selected_permiso_for_delete].permiso_uuid
    };


    authenticationService.fetchApi({
      url:'/permisos/permiso/',
      method: 'DELETE',
      body: JSON.stringify(params),
    })
    .then(result=>{
      this.setState(prevState=>({
        html:{...prevState.html,
          delete_dialog:false,
        }
        }),()=>{
          this.setState(prevState=>({
            html:{...prevState.html,
              selected_permiso_for_delete: null
            }
            }),()=>{
              this.handleLoad();
              this.props.reload(null,true);
          });
      });
      
    })
    .catch(err=>{

    });

  }
  componentDidMount(){
    // console.log(1111);
    this.handleLoad();
  }

  openDialog(index){
    
    this.setState(prevState=>({
      html:{...prevState.html,
        dialog: true,
        selected_permiso: index
      }
      }),()=>{
      // this.handleLoad()
    });
  }
  closeDialog(){
    this.setState(prevState=>({
      html:{...prevState.html,
        dialog:false,
        selected_permiso: null
      }
      }),()=>{
        
    });
  }
  openDeleteDialog(index){
    console.log('entra')
    this.setState(prevState=>({
      html:{...prevState.html,
        delete_dialog: true,
        selected_permiso_for_delete: index
      }
      }),()=>{
    });
  }
  closeDeleteDialog(){
    this.setState(prevState=>({
      html:{...prevState.html,
        delete_dialog:false,
      }
      }),()=>{
        this.setState(prevState=>({
          html:{...prevState.html,
            selected_permiso_for_delete: null
          }
          }),()=>{
            
        });
    });
  }
  handleRow(index){
    let rows = this.state.html.rows;
    rows[index] = rows.length > index && rows[index]?false:true;
    this.setState(prevState=>({
      html:{...prevState.html,
        rows: rows,
      }
      }),()=>{
      // this.handleLoad()
    });
  }


  render() {
    return (
      <>
    
      <Paper>
        <Box p={1} m={1}>

          <Box p={1}>
            <Typography variant='h5'>
              Permisos históricos
            </Typography>
          </Box>

          <Box>

            {this.state.objects.length>0 && this.state.html.list &&
            <Box p={1}>
              <TablePagination
                labelRowsPerPage='Resultados por página'
                component="div"
                count={this.state.pagination.rows_num}
                page={this.state.pagination.page}
                onPageChange={this.handleChangePage}
                rowsPerPage={this.state.pagination.rows_per_page}
                onRowsPerPageChange={this.handleChangeRowsPerPage}
              />
              <TableContainer>
                <Table size="small" >
                  <EnhancedTableHead
                    order={this.state.sorting.order}
                    orderBy={this.state.sorting.order_by}
                    onRequestSort={this.handleSort}
                  />
                  <TableBody>
                  {this.state.objects.map((object, index) => {
                    return(
                      <React.Fragment key={object.permiso_uuid} >
                      <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                        <TableCell>
                          <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => this.handleRow(index)}
                          >
                            {this.state.html.rows[index] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          <Box>
                            <Typography variant='caption'>Año proceso:</Typography>
                          </Box>
                          <Typography variant='overline' sx={{fontWeight:'bold'}}>
                            {object.agno_proceso}
                          </Typography>
                          <Box>
                            <Typography variant='caption'>Fecha última actualización:</Typography>
                          </Box>
                          <Typography variant='overline' sx={{fontWeight:'bold'}}>
                            {(new Date(object.fecha_actualizacion)).toLocaleString('es-CL')}
                          </Typography>
                        </TableCell>
                        <TableCell>

                          <Box>
                            <Box>
                              <Typography variant='caption'>Tipo:</Typography>
                            </Box>
                            <Typography variant='overline' sx={{fontWeight:'bold'}}>{object.tipo ? object.tipo:''}</Typography>
                          </Box>
                          <Box>
                            <Box>
                              <Typography variant='caption'>Patente:</Typography>
                            </Box>
                            <Typography variant='overline' sx={{fontWeight:'bold'}}>{object.vehiculo ? object.vehiculo.patente:''}</Typography>
                          </Box>
                          <Box>
                            <Typography variant='overline'>Contribuyente:</Typography>
                            <Box>
                              <Typography variant='caption'>
                                {object.contribuyente?object.contribuyente:''}
                              </Typography>
                            </Box>
                          </Box>
                        </TableCell>

                        <TableCell>
                          <Alert severity={ object.estado_consolidado===0?'warning':
                                            object.estado_consolidado===1?'success':
                                            object.estado_consolidado===2?'error':
                                            object.estado_consolidado===3?'info':
                                            object.estado_consolidado===4?'success':
                                            object.estado_consolidado===5?'warning':
                                            object.estado_consolidado===6?'warning':
                                            'info'}
                                          style={{minHeigth:'100px'}}
                                          variant={[4,5,6].includes(object.estado_consolidado)?'filled':'standard'}>
                            <Typography variant='caption' sx={{fontWeight:'bold'}}>
                              {object.estado}
                            </Typography>
                          </Alert>
                          
                          <Box>
                            <Box>
                              <Typography variant='caption'>
                              <Box sx={{display:'inline',fontWeight:'bold'}}>{object.numero_completos}</Box> sec. listas
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant='caption'>
                              <Box sx={{display:'inline',fontWeight:'bold'}}>{object.numero_rechazados} </Box>sec. rechazadas
                              </Typography>
                            </Box>
                            <Box>
                              <Typography variant='caption'>
                              <Box sx={{display:'inline',fontWeight:'bold'}}>{object.numero_incompletos} </Box>sec. incompletas
                              </Typography>
                            </Box>
                          </Box>

                        </TableCell>

                        <TableCell align="center">
                          <Typography variant='caption'>
                            

                          </Typography>

                          <Box>
                            <Typography variant='caption'>Notificaciones</Typography>
                            <Typography variant='caption' sx={{fontWeight:'bold'}}>
                              : {object.numero_notificaciones}
                            </Typography>
                          </Box>
                          {object.ultima_notificacion &&
                          <Box>
                            <Typography variant='caption'>Última notificación</Typography>
                            <Typography variant='caption' sx={{fontWeight:'bold'}}>
                              : {(new Date(object.ultima_notificacion.created_at)).toLocaleString('es-CL')}
                              <br/>({object.ultima_notificacion.who?object.ultima_notificacion.who:'Sin agente'})
                            </Typography>
                          </Box>
                          }
                        </TableCell>

                        <TableCell>
                          <Typography variant='caption'>
                            {object.agente}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Button onClick={()=>this.openDialog(index)}
                                  startIcon={<FormatListBulletedIcon />}>
                                    Ver detalles
                          </Button>

                          {['super_admin'].filter(x => authenticationService.currentUser.groups.includes(x)).length > 0 &&
                          <Button onClick={()=>this.openDeleteDialog(index)}
                                  startIcon={<DeleteIcon />}>
                                    Eliminar
                          </Button>
                          }
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                          <Collapse in={this.state.html.rows[index]} timeout="auto" unmountOnExit>
                            <Box pl={5} sx={{ margin: 1 }}>
                              <Box>
                                <Typography variant='h6' color='primary'>Estado secciones</Typography>
                                <Grid container spacing={1}>
                                  <Grid item xs={2}>
                                    <Alert  severity={ object.estado_contribuyente===0?'warning':
                                                    object.estado_contribuyente===1?'success':
                                                    object.estado_contribuyente===2?'error':
                                                    object.estado_contribuyente===3?'info':
                                                    'info'}
                                            icon={false}>
                                      <Typography variant='caption'>
                                        Contribuyente
                                      </Typography>
                                    </Alert>
                                  </Grid>
                                  <Grid item xs={2}>
                                    <Alert  severity={ object.estado_identificacion===0?'warning':
                                                    object.estado_identificacion===1?'success':
                                                    object.estado_identificacion===2?'error':
                                                    object.estado_identificacion===3?'info':
                                                    'info'}
                                            icon={false}>
                                      <Typography variant='caption'>
                                        Identificación Vehículo
                                      </Typography>
                                    </Alert>
                                  </Grid>

                                  <Grid item xs={2}>
                                    <Alert  severity={ object.estado_sii===0?'warning':
                                                    object.estado_sii===1?'success':
                                                    object.estado_sii===2?'error':
                                                    object.estado_sii===3?'info':
                                                    'info'}
                                            icon={false}>
                                      <Typography variant='caption'>
                                        Tasación SII
                                      </Typography>
                                    </Alert>
                                  </Grid>

                                  <Grid item xs={2}>
                                    <Alert  severity={ object.estado_prt===0?'warning':
                                                    object.estado_prt===1?'success':
                                                    object.estado_prt===2?'error':
                                                    object.estado_prt===3?'info':
                                                    'info'}
                                            icon={false}>
                                      <Typography variant='caption'>
                                        Revisión Técnica
                                      </Typography>
                                    </Alert>
                                  </Grid>

                                  <Grid item xs={2}>
                                    <Alert  severity={ object.estado_soap===0?'warning':
                                                    object.estado_soap===1?'success':
                                                    object.estado_soap===2?'error':
                                                    object.estado_soap===3?'info':
                                                    'info'}
                                            icon={false}>
                                      <Typography variant='caption'>
                                        Seguro obligatorio
                                      </Typography>
                                    </Alert>
                                  </Grid>


                                  <Grid item xs={2}>
                                    <Alert  severity={ object.estado_multas===0?'warning':
                                                    object.estado_multas===1?'success':
                                                    object.estado_multas===2?'error':
                                                    object.estado_multas===3?'info':
                                                    'info'}
                                            icon={false}>
                                      <Typography variant='caption'>
                                        Multas
                                      </Typography>
                                    </Alert>
                                  </Grid>

                                </Grid>
                              </Box>

                              <Box p={1} sx={{backgroundColor:"#EEEEEE"}}>
                                <Typography variant='overline'>
                                  Comentario interno
                                </Typography>
                                <pre>
                                <Typography variant='body2' color='primary'>
                                  {object.comentario_interno && object.comentario_interno!==''?object.comentario_interno:'Sin cometario'}
                                </Typography>
                                </pre>
                              </Box>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                    )
                  })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
            }
            {this.state.objects.length===0 &&
            <Box>
              <Box p={1}>
                <Alert severity='warning'>
                  No hay permisos anteriores
                </Alert>
              </Box>
            </Box>
            }
          </Box>
        </Box>
      </Paper>
      {/*
        Dialog de permiso 
       */}
      { this.state.html.dialog &&
      <Dialog   open={this.state.html.dialog}
                onClose={this.closeDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth={false} >
        <DialogContent>
          {this.state.html.dialog && 
            <Permiso  permiso={this.state.objects[this.state.html.selected_permiso]} 
                      vehiculo={null} 
                      updatePermiso={this.updatePermiso}/>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={this.closeDialog} color="secondary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      }
      {/* 
        Dialogo Delete permiso
      */}
      { this.state.html.delete_dialog &&
      <Dialog   open={this.state.html.delete_dialog}
                onClose={this.deleteDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={false}
                maxWidth={false} >
        <DialogTitle>
          Eliminar permiso 
        </DialogTitle>
        <DialogContent>
          Estás eliminando el permiso año <b>{this.state.objects[this.state.html.selected_permiso_for_delete].agno_proceso}</b>
          &nbsp;para el vehículo <b>{this.state.objects[this.state.html.selected_permiso_for_delete].vehiculo.patente}</b>.
          <br/>
          ¿Estás seguro que deseas eliminar este permiso? Esta acción es irreversible.
        </DialogContent>
        <DialogActions>

          <Button onClick={this.deletePermiso} color="secondary" variant="contained">
            Confirmar
          </Button>
          <Button onClick={this.closeDeleteDialog} color="secondary" variant="outlined">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
      }

      </>

    );
  }
}

export default withRouter(PermisosHistoricos);
